// extracted by mini-css-extract-plugin
export default {"card":"ng_card_card__seobS","card__image":"ng_card_card__image__0wxz6","card__title":"ng_card_card__title__MFKIV"};